import { AppRouter } from "./routes";

export const App = ()=> {
  return (
    <AppRouter />
  );
}
